/**
 * 角色管理 API
 */

import { http } from '../request';
import type { Role, RoleListResponse, RoleQueryParams } from '../../types/role';

/**
 * 分页查询角色列表
 */
export function getRolePage(params?: RoleQueryParams): Promise<RoleListResponse> {
  return http.get<RoleListResponse>('/system/role/page', params);
}

/**
 * 查询所有角色列表（下拉框用）
 */
export function getAllRoles(): Promise<Role[]> {
  return http.get<Role[]>('/system/role/list');
}

/**
 * 根据 ID 查询角色详情
 */
export function getRoleById(id: number): Promise<Role> {
  return http.get<Role>(`/system/role/${id}`);
}

/**
 * 创建角色
 */
export function createRole(data: Role): Promise<void> {
  return http.post('/system/role', data);
}

/**
 * 更新角色
 */
export function updateRole(data: Role): Promise<void> {
  // 后端 @PutMapping 不带路径变量，请求体需要包含 id
  return http.put('/system/role', data);
}

/**
 * 删除角色
 */
export function deleteRole(id: number): Promise<void> {
  return http.delete(`/system/role/${id}`);
}

/**
 * 获取角色的菜单 ID 列表
 */
export function getRoleMenus(id: number): Promise<number[]> {
  return http.get<number[]>(`/system/role/${id}/menus`);
}

/**
 * 分配角色菜单权限
 */
export function assignRoleMenus(id: number, menuIds: number[]): Promise<void> {
  return http.put(`/system/role/${id}/menus`, menuIds);
}
